const omitNullishProperties = (obj) => {
  // this func removes nullish propertes (null, undefined) but keeps falsy values ("", 0, false)

  // Need to map the value, but not use it
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== null && v !== undefined));
};

export default omitNullishProperties;
